import { getWishlist, removeFromWishlist } from '../utils/wishlist';
import { useEffect, useState } from 'react';

function Wishlist() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) {
      alert("Please log in to use your wishlist.");
      window.location.href = "/login";
    } else {
      setItems(getWishlist());
    }
  }, []);
  

  const removeItem = (id) => {
    removeFromWishlist(id);
    setItems(getWishlist());
  };

  return (
    <div style={{ padding: "30px" }}>
      <h2>My Wishlist 💖</h2>
      {items.length === 0 ? (
        <p>Your wishlist is empty.</p>
      ) : (
        <ul>
          {items.map((item, index) => (
            <li key={index} style={{ marginBottom: "10px" }}>
              {item.title} - <strong>{item.price}</strong>
              <button onClick={() => removeItem(item.id)} style={{ marginLeft: "10px", color: "red" }}>
                Remove
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default Wishlist;
